import React from 'react';
import { PLATFORMS, SME_TABS } from '../../utils/smeIpos';

const TAB_COUNT_TONES = {
  all: 'bg-teal-100 text-[#006666]',
  open: 'bg-emerald-100 text-emerald-700',
  upcoming: 'bg-sky-100 text-sky-700',
  closed: 'bg-slate-200/80 text-slate-600',
};

const PLATFORM_OPTIONS = [{ key: 'all', label: 'All Platforms' }, ...Object.entries(PLATFORMS).map(([key, label]) => ({ key, label }))];

// Status tabs plus platform chips; clicking the active chip clears it
export const SmeControls = ({ tab, onTabChange, tabCounts, platform, onPlatformChange, platformCounts }) => (
  <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-3 bg-white rounded-2xl border border-slate-200/90 shadow-sm p-2.5 sm:p-3">
    <div role="group" aria-label="Bidding status" className="inline-flex self-start gap-1 p-1 rounded-xl bg-slate-100 border border-slate-200/80 max-w-full overflow-x-auto">
      {SME_TABS.map((option) => {
        const active = option.key === tab;
        return (
          <button
            key={option.key}
            type="button"
            aria-pressed={active}
            onClick={() => onTabChange(option.key)}
            className={`inline-flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-1.5 rounded-lg text-xs font-bold whitespace-nowrap transition-all ${
              active ? 'bg-white text-[#008080] shadow-sm' : 'text-slate-600 hover:text-slate-900'
            }`}
          >
            <span className="sm:hidden">{option.shortLabel}</span>
            <span className="hidden sm:inline">{option.label}</span>
            <span className={`px-1.5 py-px rounded-full text-[10px] font-extrabold ${TAB_COUNT_TONES[option.key]}`}>{tabCounts[option.key]}</span>
          </button>
        );
      })}
    </div>

    <div role="group" aria-label="Filter by platform" className="flex flex-wrap items-center gap-1.5">
      <span className="text-[11px] font-semibold text-slate-400 mr-0.5">Platform:</span>
      {PLATFORM_OPTIONS.map((option) => {
        const active = option.key === platform;
        return (
          <button
            key={option.key}
            type="button"
            aria-pressed={active}
            onClick={() => onPlatformChange(active && option.key !== 'all' ? 'all' : option.key)}
            className={`px-2.5 py-1 rounded-full border text-[11px] font-bold whitespace-nowrap transition-colors ${
              active ? 'border-[#008080] bg-[#008080] text-white' : 'border-slate-200 bg-slate-50 text-slate-600 hover:bg-slate-100'
            }`}
          >
            {option.label} ({platformCounts[option.key] || 0})
          </button>
        );
      })}
    </div>
  </div>
);

export default SmeControls;
